import { render, staticRenderFns } from "./transHold.vue?vue&type=template&id=53c9696c&scoped=true"
import script from "./transHold.vue?vue&type=script&lang=js"
export * from "./transHold.vue?vue&type=script&lang=js"
import style0 from "./transHold.vue?vue&type=style&index=0&id=53c9696c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9696c",
  null
  
)

export default component.exports